import { c as _c } from "react/compiler-runtime";
import { LanguageCodeEnum, getLocaleByLanguageCode } from '@systemeio/ui';
import { useLanguageSwitcher } from 'shared/components/language-switcher/hooks/use-language-switcher';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from '../../hooks/use-user';
import { LanguageSwitcher } from './language-switcher';
export function MobileLanguageSwitcher() {
  const $ = _c(6);
  const {
    i18n
  } = useLocoTranslation();
  const {
    isLoading
  } = useUser();
  const {
    handleChangeLanguage,
    isChangingLanguage
  } = useLanguageSwitcher();
  const t0 = i18n.language as LanguageCodeEnum;
  let t1;
  if ($[0] !== t0) {
    t1 = getLocaleByLanguageCode(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isChangingLanguage || !i18n || isLoading;
  let t3;
  if ($[2] !== handleChangeLanguage || $[3] !== t1 || $[4] !== t2) {
    t3 = <LanguageSwitcher changeLanguage={handleChangeLanguage} selectedLanguage={t1} isFetching={t2} buttonClassName="leading-6" />;
    $[2] = handleChangeLanguage;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}